export default function load_newsletterSignUpCaptcha() {
  // Check if reCAPTCHA is already loaded and ready
  if (typeof grecaptcha !== "undefined" && grecaptcha.render) {
    render_newsletterSignUpCaptcha();
    return;
  }

  // Set up the callback function before loading the script
  window.onRecaptchaReady = render_newsletterSignUpCaptcha;

  // Load the reCAPTCHA script with callback parameter
  const script = document.createElement("script");
  script.src = "https://www.google.com/recaptcha/api.js?onload=onRecaptchaReady&render=explicit";
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}

function render_newsletterSignUpCaptcha() {
  const recaptchaContainer = document.getElementById("recaptcha_v2_widget");

  if (recaptchaContainer && typeof grecaptcha !== "undefined" && grecaptcha.render) {
    // Clear any existing reCAPTCHA
    recaptchaContainer.innerHTML = "";

    try {
      // Render new reCAPTCHA
      grecaptcha.render("recaptcha_v2_widget", {
        sitekey: "6Lfhcd0SAAAAAOBEHmAVEHJeRnrH8T7wPvvNzEPD",
        theme: "light",
        size: "normal",
      });
    } catch (error) {
      console.error("Error rendering reCAPTCHA:", error);
    }
  }
}
